import ErrorBoundary from "@Components/ErrorBoundary";
import { getVirtualViewSrc } from "@Pages/PropertyPage/components/SectionFeatured.tsx/utils";
import wrapperHOC from "@Utils/wrapperHOC";

const ThreeDView = ({ item, events }: any) => {
  const imgSrc = getVirtualViewSrc(item, true);
  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const isYT9216BJ = userAgent.includes("YT9216BJ");

  return (
    <ErrorBoundary isComponentLevel noErrorLog>
      <iframe
        title="3DView"
        sandbox="allow-scripts allow-same-origin allow-popups allow-modals allow-presentation"
        allowFullScreen={!isYT9216BJ}
        src={imgSrc}
        width="100%"
        height="100%"
        style={{
          pointerEvents: events,
        }}
      />
    </ErrorBoundary>
  );
};

export default wrapperHOC(ThreeDView, {
  componentName: "ThreeDView-GalleryModal-PropertyPage",
  showForChina: true,
});
